import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Sparkles, Stars, Heart, ShieldCheck, MessagesSquare, Compass } from 'lucide-react';
import { SCShell, SCHeading, goldBtn, ghostBtn, getCustToken } from './sc/SCShared';

const steps = [
  { icon: Compass, t: 'Create your profile', d: 'Share your values, spiritual path, lifestyle and intentions.' },
  { icon: Stars, t: 'Discover shared resonance', d: 'See real shared interests — no black-box “soulmate” claims.' },
  { icon: Heart, t: 'Match & connect', d: 'When you both like each other, a connection opens.' },
  { icon: MessagesSquare, t: 'Start a conversation', d: 'Message intentionally, on your terms.' },
];

const SacredConnections = () => {
  const navigate = useNavigate();
  const authed = !!getCustToken();
  return (
    <SCShell>
      <div className="text-center max-w-3xl mx-auto">
        <p className="font-jost text-xs tracking-[0.5em] text-[#d946ef] uppercase mb-5">Prestige Elements</p>
        <h1 className="font-cinzel text-4xl md:text-6xl leading-tight" style={{ background: 'linear-gradient(90deg,#f5d786,#e9d8ff,#c4b5fd)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Sacred Connections</h1>
        <p className="font-cormorant text-2xl text-[#e9d8ff]/80 mt-5">Meet people who resonate with your values, spirit, and way of life.</p>
        <p className="font-jost text-[#e9d8ff]/60 mt-5 leading-relaxed">A space for adults seeking meaningful relationships with people who share their interests, lifestyles, spiritual curiosity, and intentions.</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
          <button data-testid="sc-landing-start" className={goldBtn} onClick={() => navigate(authed ? '/sacred-connections/onboarding' : '/account')}>
            <Sparkles className="h-4 w-4" /> {authed ? 'Create your profile' : 'Log in to begin'}
          </button>
          <Link to="/sacred-connections/safety" className={ghostBtn} data-testid="sc-landing-safety"><ShieldCheck className="h-4 w-4" /> Safety Center</Link>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-20">
        {steps.map((s, i) => (
          <div key={i} className="rounded-2xl p-6 border border-[#8b5cf6]/20 bg-white/[0.03] backdrop-blur-md">
            <div className="h-12 w-12 rounded-full border border-[#d946ef]/40 flex items-center justify-center mb-4"><s.icon className="h-5 w-5 text-[#e9d8ff]" /></div>
            <h3 className="font-cinzel text-base text-[#f5d786] mb-1">{s.t}</h3>
            <p className="font-jost text-sm text-[#e9d8ff]/60">{s.d}</p>
          </div>
        ))}
      </div>

      <p className="text-center font-cormorant italic text-xl text-[#e9d8ff]/60 mt-16">Your connection. Your intentions. Your journey.</p>
      <p className="text-center font-jost text-xs text-[#e9d8ff]/40 mt-4">Adults 18+ only. Sacred Connections is separate from your shopping account and always optional.</p>
    </SCShell>
  );
};

export default SacredConnections;
